
import { defineComponent, reactive, ref } from 'vue';

import { useList } from '@/hooks/use-list';
import CustomTable from '@/components/custom-table';
import { renderColumns } from './composables/tableData';

import OperationDrawer from '@/components/operation-drawer/index.vue';
import AddressPicker from '@/components/address-picker/index.vue';
import CreateRegionalDialog from './components/create-regional-dialog.vue';
import usePermissionConfig from '../../use-permission-config';

import {
  regionAreaPageApi,
  regionAreaLogApi,
} from '../../api/index';
import {
  IZoneAreaPageReq,
  IZoneAreaPageRes,
} from '../../api/types';

export default defineComponent({
  name: 'RegionalSettingList',
  components: {
    CustomTable,
    OperationDrawer,
    AddressPicker,
    CreateRegionalDialog,
  },
  setup() {
    // 选择地址
    const addressList = ref<string[]>([]);
    const handleChangeAddress = (list: string[]) => {
      addressList.value = list;
    };

    const permissionConfig = usePermissionConfig();

    const queryParams: IZoneAreaPageReq = {
      pageNum: 1,
      pageSize: 10,
      provinceName: '', // 省名称
      provinceCode: '',
      cityName: '',
      cityCode: '',
    };
    const {
      params,
      tableTotal,
      tableData,
      handleSearch,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IZoneAreaPageRes, IZoneAreaPageReq>({
      request: {
        api: regionAreaPageApi,
        params: queryParams,
        handleParams: (paramsObj) => {
          if (addressList.value.length > 1) {
            [paramsObj.provinceName, paramsObj.cityName] = addressList.value;
          }
          return {
            ...paramsObj,
          };
        },
      },
    });
    handleSearch();

    // 重置
    const handleReset = () => {
      addressList.value = [];
      handleSearch();
    };

    // 创建区域
    const regional = reactive({
      visible: false,
      regionId: '',
    });

    const handleRegionalSetting = (regionId: string = '') => {
      regional.regionId = regionId;
      regional.visible = true;
    };

    // 操作日志
    const operation = reactive({
      visible: false,
      regionId: '',
    });
    const handleOperation = (id: string) => {
      operation.regionId = id;
      try {
        console.log(id);
      } catch (e) {
        console.log(e);
      }
      operation.visible = true;
    };

    return {
      params,
      tableTotal,
      tableData,
      operation,
      regional,
      config: {
        timeKey: 'createdTime',
        userKey: 'creatorName',
        contentKey: 'content',
        remarkKey: 'remark',
      },
      addressList,
      permissionConfig,
      regionAreaLogApi,

      renderColumns,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      handleRegionalSetting,
      handleOperation,
      handleChangeAddress,

    };
  },
});
